















































import { last, forEach } from 'lodash-es'
import AjaxButton from '@/components/AjaxButton.vue'
import Selectize from '../Selectize.vue'
import { Icon, Button } from '@alpha/ink'

import api from '@/api'
import { reportSourceType } from '@/utilities/test-helpers.js'
import ToastAlert from '@/components/Toast.vue'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import analytics from '@/analytics'

export interface Window {
  [key:string]: any; // Add index signature
}

@Component({
  components: {
    AjaxButton,
    Selectize,
    Button,
    Icon,
    ToastAlert
  }
})
export default class CTAShare extends Vue {
  @Prop() report!:any
  @Prop() session!:any

  showBubble:boolean = false
  shareUrl:string = window.location.href
  message:any = {
    type: false,
    text: ''
  }

  emails:any = []
  btnText:string = 'Send'
  email:string = ''
  note:string = ''
  window:Window = window
  toast:string | false = false

  get reportId ():any {
    return last(this.shareUrl.split('/'))
  }

  @Watch('emails')
  onEmailsChange () {
    this.validateAllEmails()
  }

  toggleBubble (show:any) {
    this.showBubble = !show ? show : !this.showBubble
    if (this.showBubble) this.trackAnalytics('open')
  }

  modifyEmails (data:any) {
    data = data.replace(/"/g, '')
    this.emails = data ? data.split(',') : []
  }

  addEmail (data:any) {
    data = data.replace(/"/g, '')
    this.emails.push(data)
  }

  addMessage (type:string) {
    switch (type) {
      case 'clear':
        this.message.type = false
        break
      case 'missing_email':
        this.message.type = 'emailError'
        this.message.text = '* Required'
        break
      case 'invalid_email':
        this.message.type = 'emailError'
        this.message.text = '* Please enter a valid email'
        break
      case 'success':
        this.message.type = 'success'
        this.message.text = 'Email Sent'
        break
      default:
        this.message.type = 'error'
        this.message.text = 'Something went wrong. Please try again.'
        break
    }
  }

  copyLink () {
    this.trackAnalytics('copy')
    var link = this.$refs.link
    this.window.getSelection().removeAllRanges()
    var range:any = document.createRange()
    range.selectNode(link)
    this.window.getSelection().addRange(range)
    try {
      var success = document.execCommand('copy')
      if (success) {
        this.toast = 'Copied sharing link to clipboard.'
      } else {
        this.toast = 'Couldnt copy'
      }
    } catch (err) {
      console.error('Oops, couldnt copy', err)
    }
    this.window.getSelection().removeAllRanges()
    setTimeout(() => {
      this.toast = false
    }, 5000)
  }

  validateEmail (email:string):boolean {
    var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailPattern.test(email)
  }

  validateAllEmails ():boolean {
    var that = this
    var valid = true
    forEach(this.emails, function (e) {
      if (valid) {
        if (!that.validateEmail(e)) {
          that.addMessage('invalid_email')
          valid = false
        }
      }
    })
    if (valid) this.addMessage('clear')
    return valid
  }

  submit (receiver:any) {
    var originalBtnText = this.btnText
    var that = this
    this.addMessage('clear')
    if (this.emails.length === 0) {
      this.$nextTick(function () {
        that.addMessage('missing_email')
        receiver.finish()
      })
      return
    } else if (!this.validateAllEmails()) {
      this.$nextTick(function () {
        receiver.finish()
      })
      return
    }

    var data = {
      session: this.session,
      emails: this.emails,
      note: this.note,
      client_name: this.report.client.name,
      report_id: this.reportId,
      title: this.report.title
    }
    this.btnText = 'Sending...'
    that.trackAnalytics('submit')

    api.shareSharedReport(data)
      .then(function () {
        that.trackAnalytics('emails_sent')
        that.emails.forEach(function (e:any) {
          const selectizeRef:any = that.$refs.selectize
          selectizeRef.removeOption(e)
        })
        that.emails.splice(0, that.emails.length)
        that.note = ''
        that.$nextTick(function () {
          that.addMessage('success')
        })
      })
      .catch(function (e:any) {
        that.addMessage('error')
        console.error(e)
      })
      .finally(function () {
        that.$nextTick(function () {
          that.btnText = originalBtnText
          receiver.finish()
        })
        setTimeout(function () { that.message.type = false }, 3000)
      })
  }

  trackAnalytics (action:any) {
    // submit, emails_sent, copy, open
    var that = this
    var sourceId = this.report.config ? this.report.config.id : this.report.client.viewId
    var emails = action.indexOf('emails') !== -1 ? this.emails.length : false
    var name = this.session.firstname || false
    if (name && this.session.lastname) name += ' ' + this.session.lastname

    analytics.track('Shared Reports Share To Other Users', {
      module: 'email_bubble',
      action: action,
      sourceId: sourceId,
      sourceType: reportSourceType(this.report),
      note: that.note.length > 0,
      loggedIn: !!that.session.firstname,
      emails: emails
    })
  }
}
